<template>
  <account-template
    icon="icons/google-search-console"
    :account="searchConsole"
    account-name="Search Console"
    connection-href="/google/connect/Console/onboarding"
    :connected-data="connectedData"
  />
</template>

<script>
import {mapGetters} from "vuex";
import AccountTemplate from "./AccountTemplate";

export default {
  components: {
    AccountTemplate,
  },
  computed: {
    ...mapGetters('onboarding', [
      'searchConsole',
    ]),
    connectedData() {
      if (!this.searchConsole) {
        return null;
      }
      return [
        {
          'title': 'Console URL',
          'value': this.searchConsole.console_url ?? null,
        },
      ]
    }
  }
}
</script>

